<template>
  <!-- 模板部分不变，保持原样 -->
  <div class="promoter-container">
    <el-card class="admin-list-card" shadow="never">
      <template #header>
        <span>用户列表</span>
      </template>

      <div class="filter-container">
        <el-select v-model="statusFilter" placeholder="全部状态" clearable style="width: 150px; margin-right: 10px"
          @change="fetchData(1)">
          <el-option label="正常" value="正常" />
          <el-option label="已禁用" value="已拉黑" />
        </el-select>
        <el-input v-model="searchQuery" placeholder="搜索手机号、用户名或邀请码" style="width: 260px; margin-right: 10px"
          @keyup.enter="handleSearch" />
        <el-button type="primary" @click="handleSearch()">搜索</el-button>
        <el-button type="primary" @click="handleReset()">重置</el-button>

      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="phone" label="手机号" width="135" />
        <el-table-column prop="username" label="用户名" min-width="120" />
        <el-table-column prop="lcode" label="邀请码" width="110" />
        <el-table-column prop="ownInviteCode" label="我的推广码" width="120" />
        <el-table-column prop="divide" label="分成比例" width="100" />
        <el-table-column prop="number" label="推广人数" width="90" />
        <el-table-column prop="points" label="积分" width="100" />
        <el-table-column prop="memberText" label="会员状态" min-width="170" />
        <el-table-column prop="state" label="状态">
          <template #default="{ row }">
            <el-tag :type="row.state === '正常' ? 'success' : 'danger'">
              {{ row.state }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Creationtime" label="注册时间" min-width="170" />
        <el-table-column label="操作" width="160">
          <template #default="scope">
            <el-button size="small" type="primary" @click="handleDetail(scope.row)"> 详情 </el-button>
            <el-button size="small" type="warning" @click="handleToggleStatus(scope.row)">
              {{ scope.row.state === "正常" ? "拉黑" : "恢复" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
          @current-change="handlePageChange" />
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import { useRouter } from "vue-router";
import store from "../../store/index";

const searchQuery = ref("");
const statusFilter = ref("");
const tableData = ref([]);
const router = useRouter();
// 分页参数（直接用后端返回的 total）
const currentPage = ref(1);
const pageSize = ref(15);
const total = ref(0); // 只存后端返回的总条数，不再被前端覆盖

// 核心：请求后端数据（带筛选+分页参数）
const fetchData = async (page = 1) => {
  try {
    const res = await axios.get(`/admin/getmac`, {
      params: {
        page, // 当前页
        pageSize: pageSize.value, // 每页条数
        searchQuery: searchQuery.value.trim(), // 搜索关键词（传给后端筛选）
        status: statusFilter.value
      }
    });
    console.log("后端返回数据", res);
    if (res.data.msg !== "success") {
      throw new Error(res.data.data || "达人列表加载失败");
    }
    tableData.value = (res.data.data || []).map((item) => ({
      ...item,
      lcode: item.lcode || "无",
      ownInviteCode: item.ownInviteCode || "未生成",
      Creationtime: item.Creationtime && !Number.isNaN(new Date(item.Creationtime).getTime())
        ? new Date(item.Creationtime).toLocaleString()
        : "-",
      divide: `${Number(item.divide || 0).toFixed(2)}%`,
      number: Number(item.number ?? item.totalPromote ?? 0),
      points: Number(item.points || 0),
      memberText: Number(item.vip) > 0
        ? `会员${item.vipTime ? ` · ${new Date(item.vipTime).toLocaleDateString()}` : ""}`
        : "非会员"
    }));

    // 关键：直接赋值后端返回的总条数（不会被前端逻辑覆盖）
    total.value = Number(res.data.total);
    currentPage.value = page; // 更新当前页
  } catch (error) {
    ElMessage.error("数据加载失败");
    console.error(error);
  }
};

// 初始化加载第1页数据
fetchData();

// 搜索按钮：重置到第1页，重新请求后端
const handleSearch = () => {
  fetchData(1)
};

const handleReset = () => {
  // 步骤1：恢复筛选条件到初始值
  searchQuery.value = ""; // 清空搜索框
  // 步骤2：重置到第1页，请求初始数据
  fetchData(1);

  // 步骤3：提示重置成功
  ElMessage.success("重置完成，已恢复初始状态");
};


// 分页切换：请求对应页数据
const handlePageChange = (page) => {
  fetchData(page); // 切换页码时，带当前筛选条件请求后端
};



// 以下功能保持不变（详情、拉黑/恢复、删除）
const handleDetail = (row) => {
  console.log("查看详情:", row);
  store.commit("userphone", row);
  router.push("/user-manage/Userlog");
};

const handleToggleStatus = (row) => {
  const newStatus = row.state === "正常" ? "已拉黑" : "正常";
  ElMessageBox.confirm(`确定要${newStatus === "已拉黑" ? "拉黑" : "恢复"}该推广人吗？`, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      // 注意：这里只是前端临时切换，实际需要调用后端接口更新状态
      const res = await axios.post(`/admin/blacklist`, {
        phone: row.phone, // 手机号
        lcode: row.lcode, // 邀请码
        state: newStatus
      });
      console.log("操作结果", res)
      if (res.data.msg == "success") {
        row.state = newStatus;
        ElMessage.success("结果：" + res.data.data);
        fetchData(currentPage.value);//刷新
      } else {
        ElMessage.error("失败：" + res.data.data);
      }
    })
    .catch((error) => {
      ElMessage.error("失败：" + error);
    });
};

</script>

<style scoped>
/* 样式保持不变 */
.promoter-container {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
